import { render, staticRenderFns } from "./SdcmHeader.vue?vue&type=template&id=3c47bc6e&scoped=true&"
import script from "./SdcmHeader.vue?vue&type=script&lang=js&"
export * from "./SdcmHeader.vue?vue&type=script&lang=js&"
import style0 from "./SdcmHeader.vue?vue&type=style&index=0&id=3c47bc6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47bc6e",
  null
  
)

export default component.exports